(function () {
  const menuToggle = document.querySelector('[data-tie-menu-toggle]');
  const mobileMenu = document.querySelector('[data-tie-mobile-menu]');
  const header = document.querySelector('.tie-header');
  const body = document.body;
  const sideCart = document.querySelector('[data-tie-side-cart]');
  const sideCartBody = sideCart ? sideCart.querySelector('[data-tie-side-cart-body]') : null;
  const sideCartFooter = sideCart ? sideCart.querySelector('[data-tie-side-cart-footer]') : null;
  const sideCartUpsellScript = sideCart ? sideCart.querySelector('[data-tie-side-cart-upsells]') : null;
  const searchModal = document.querySelector('[data-tie-search-modal]');
  const searchInput = searchModal ? searchModal.querySelector('[data-tie-search-input]') : null;
  const moneyFormat = body?.dataset.moneyFormat || 'Rs. {{amount}}';
  const fallbackCartImage = sideCartBody?.dataset.tieCartFallbackImage || '';
  const sideCartUpsellHeading = sideCart?.dataset.tieSideCartUpsellHeading || 'Bestsellers to pair with it';
  let sideCartUpsells = [];

  if (sideCartUpsellScript) {
    try {
      sideCartUpsells = JSON.parse(sideCartUpsellScript.textContent || '[]');
    } catch (error) {
      sideCartUpsells = [];
    }
  }

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const [whole, decimal] = amount.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountNoZeros = decimal === '00' ? withCommas : `${withCommas}.${decimal}`;
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/g, amountNoZeros)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountNoZeros.replace(/\./g, ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas.replace(/\./g, ','));
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const setupReadMoreCards = () => {
    document.querySelectorAll('[data-tie-read-more]').forEach((button) => {
      if (button.dataset.tieReadMoreReady === 'true') return;
      const container = button.closest('[data-tie-read-more-wrap]') || button.closest('.tie-review-card');
      const copy = container ? container.querySelector('[data-tie-read-more-copy]') : null;
      if (!container || !copy) return;

      const sync = () => {
        const isExpanded = container.classList.contains('is-expanded');
        if (isExpanded) {
          container.classList.add('has-read-more');
          return;
        }

        container.classList.toggle('has-read-more', copy.scrollHeight > copy.clientHeight + 2);
      };

      button.dataset.tieReadMoreReady = 'true';
      button.addEventListener('click', () => {
        const expanded = !container.classList.contains('is-expanded');
        container.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'Read less' : 'Read more';
        sync();
      });

      requestAnimationFrame(sync);
      window.addEventListener('resize', sync, { passive: true });
    });
  };

  const openSideCart = () => {
    if (!sideCart) return;
    sideCart.classList.add('is-open');
    sideCart.setAttribute('aria-hidden', 'false');
    body.classList.add('tie-body-lock');
  };

  const closeSideCart = () => {
    if (!sideCart) return;
    sideCart.classList.remove('is-open');
    sideCart.setAttribute('aria-hidden', 'true');
    body.classList.remove('tie-body-lock');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-tie-cart-count]').forEach((node) => {
      node.textContent = String(count);
    });
  };

  const bagIconMarkup = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M7 9.5h10l-.8 9H7.8l-.8-9Z"></path><path d="M9 9.5V7a3 3 0 0 1 6 0v2.5"></path></svg>';

  const getFormVariantId = (form) => {
    if (!form) return '';
    const formData = new FormData(form);
    return String(formData.get('id') || '');
  };

  const syncAddToBagButtons = (cart) => {
    const cartVariantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));

    document.querySelectorAll('form[data-tie-add-to-cart]').forEach((form) => {
      const button = form.querySelector('button[type="submit"]:not([name="checkout"])');
      if (!button) return;

      if (!button.dataset.tieDefaultHtml) {
        button.dataset.tieDefaultHtml = button.innerHTML;
      }

      const isInCart = cartVariantIds.has(getFormVariantId(form));
      button.classList.toggle('is-success', isInCart);

      if (isInCart) {
        button.innerHTML = `Added to Bag ${bagIconMarkup}`;
      } else if (!button.classList.contains('is-loading')) {
        button.innerHTML = button.dataset.tieDefaultHtml;
      }
    });
  };

  const renderSideCartUpsells = (cart) => {
    if (!sideCartUpsells.length) return '';

    const cartProductIds = new Set((cart.items || []).map((item) => Number(item.product_id)));
    const availableUpsells = sideCartUpsells
      .filter((product) => product.available && !cartProductIds.has(Number(product.product_id)))
      .slice(0, 4);

    if (!availableUpsells.length) return '';

    const upsellCards = availableUpsells.map((product) => `
      <article class="tie-side-cart__upsell-card">
        <a class="tie-side-cart__upsell-image" href="${escapeHtml(product.url)}">
          <img src="${escapeHtml(product.image || fallbackCartImage)}" alt="${escapeHtml(product.title)}" loading="lazy">
        </a>
        <div class="tie-side-cart__upsell-copy">
          <h4><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h4>
          <p>${escapeHtml(formatMoney(product.price))}</p>
        </div>
        <button class="tie-side-cart__upsell-button" type="button" data-tie-cart-upsell-add="${Number(product.variant_id)}">Add</button>
      </article>
    `).join('');

    return `
      <section class="tie-side-cart__upsells" aria-labelledby="TieSideCartUpsellsTitle">
        <div class="tie-side-cart__upsells-header">
          <p class="tie-eyebrow">Pair it with</p>
          <h3 id="TieSideCartUpsellsTitle">${escapeHtml(sideCartUpsellHeading)}</h3>
        </div>
        <div class="tie-side-cart__upsells-list">${upsellCards}</div>
      </section>
    `;
  };

  const getCartInventory = async () => {
    try {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopifyRoot}?section_id=tie-cart-inventory`, {
        cache: 'no-store',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return {};

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const inventoryScript = documentFragment.querySelector('[data-tie-cart-inventory]');

      if (!inventoryScript) return {};

      return JSON.parse(inventoryScript.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const getVariantInventoryLimit = (item, inventoryByVariant) => {
    const inventory = inventoryByVariant?.[String(item.variant_id)];

    if (!inventory || !inventory.tracked || inventory.policy !== 'deny') {
      return null;
    }

    const availableQuantity = Number(inventory.quantity);
    return Number.isFinite(availableQuantity) ? Math.max(0, availableQuantity) : null;
  };

  const renderCartItems = (cart, inventoryByVariant = {}) => {
    if (!sideCartBody || !sideCartFooter) return;

    const upsellMarkup = renderSideCartUpsells(cart);
    const quantitiesByVariant = (cart.items || []).reduce((totals, item) => {
      const variantId = String(item.variant_id);
      totals[variantId] = (totals[variantId] || 0) + Number(item.quantity || 0);
      return totals;
    }, {});

    if (!cart.item_count) {
      sideCartBody.innerHTML = `
        <div class="tie-side-cart__empty">
          <p class="tie-eyebrow">Cart</p>
          <h3>Your bag is quiet for now.</h3>
          <p>Start with a structured handbag, then add the small pieces that make it yours.</p>
        </div>
        ${upsellMarkup}
      `;
    } else {
      const itemsMarkup = cart.items.map((item, index) => {
        const image = item.featured_image?.url
          ? `<img src="${escapeHtml(item.featured_image.url)}&width=240" alt="${escapeHtml(item.product_title)}" loading="lazy">`
          : `<img src="${escapeHtml(fallbackCartImage)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`;
        const inventoryLimit = getVariantInventoryLimit(item, inventoryByVariant);
        const totalVariantQuantity = quantitiesByVariant[String(item.variant_id)] || 0;
        const isAtInventoryLimit = inventoryLimit !== null && totalVariantQuantity >= inventoryLimit;
        const nextQuantity = isAtInventoryLimit ? item.quantity : item.quantity + 1;
        const stockNote = inventoryLimit !== null
          ? `<p class="tie-side-cart__stock-note" role="status">Only ${inventoryLimit} left in stock</p>`
          : '';

        return `
          <article class="tie-side-cart__item">
            <a class="tie-side-cart__image" href="${escapeHtml(item.url)}">${image}</a>
            <div class="tie-side-cart__details">
              <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
              ${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
              <div class="tie-side-cart__meta">
                <span class = "money">${escapeHtml(formatMoney(item.final_line_price))}</span>
              </div>
              ${stockNote}
              <div class="tie-side-cart__quantity">
                <button type="button" aria-label="Decrease quantity" data-tie-cart-change="${index + 1}" data-tie-cart-quantity="${Math.max(0, item.quantity - 1)}">-</button>
                <span>${item.quantity}</span>
                <button
                  type="button"
                  aria-label="Increase quantity"
                  data-tie-cart-change="${index + 1}"
                  data-tie-cart-quantity="${nextQuantity}"
                  ${isAtInventoryLimit ? 'disabled aria-disabled="true" title="Maximum available quantity reached"' : ''}
                >+</button>
              </div>
              <button class="tie-side-cart__remove" type="button" data-tie-cart-change="${index + 1}" data-tie-cart-quantity="0">Remove</button>
            </div>
          </article>
        `;
      }).join('');

      sideCartBody.innerHTML = `${itemsMarkup}${upsellMarkup}`;
    }

    sideCartFooter.innerHTML = `
      <div class="tie-side-cart__summary">
        <span class= "money">Subtotal</span>
        <strong>${escapeHtml(formatMoney(cart.total_price))}</strong>
      </div>
      <form action="/cart" method="post" id="CartDrawer-Form">
        <button class="tie-button" type="submit" name="checkout" id="CartDrawer-Checkout">Checkout</button>
      </form>
    `;

    updateCartCount(cart.item_count);
    syncAddToBagButtons(cart);
  };

  const refreshCart = async (openAfterUpdate) => {
    if (!sideCart) return;

    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const [cartResponse, inventoryByVariant] = await Promise.all([
      fetch(`${shopifyRoot}cart.js`, {
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }),
      getCartInventory()
    ]);

    if (!cartResponse.ok) return;

    const cart = await cartResponse.json();
    renderCartItems(cart, inventoryByVariant);

    if (openAfterUpdate) {
      openSideCart();
    }
  };

  const setSubmitting = (form, submitting, submitter = null) => {
    const button = submitter || form?.querySelector('button[type="submit"]:not([data-tie-buy-now])');
    if (!button) return;

    button.disabled = submitting;
    button.classList.toggle('is-loading', submitting);

    if (!submitting) {
      button.classList.remove('is-loading');
    }

    if (!button.dataset.tieDefaultHtml) {
      button.dataset.tieDefaultHtml = button.innerHTML;
    }

    if (submitting) {
      button.innerHTML = button.matches('[data-tie-buy-now]') ? 'OPENING CART...' : 'Adding...';
    } else if (!button.classList.contains('is-success')) {
      button.innerHTML = button.dataset.tieDefaultHtml;
    }
  };

  const showButtonSuccess = (form) => {
    const button = form?.querySelector('button[type="submit"]');
    if (!button) return;
    if (!button.dataset.tieDefaultHtml) {
      button.dataset.tieDefaultHtml = button.innerHTML;
    }
    button.classList.remove('is-loading');
    button.classList.add('is-success');
    button.innerHTML = `Added to Bag ${bagIconMarkup}`;
  };

  const syncVariantInputs = (value) => {
    if (!value) return;
    document.querySelectorAll('[data-tie-variant-sync]').forEach((input) => {
      input.value = value;
    });
  };
  const closeHeaderDropdowns = (exceptDropdown = null) => {
  document.querySelectorAll('.tie-header-dropdown[open]').forEach((dropdown) => {
    if (dropdown !== exceptDropdown) {
      dropdown.open = false;
    }
  });
};

document.querySelectorAll('.tie-header-dropdown').forEach((dropdown) => {
  dropdown.addEventListener('toggle', () => {
    if (dropdown.open) {
      closeHeaderDropdowns(dropdown);
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.tie-header-dropdown')) {
    closeHeaderDropdowns();
  }
});

window.addEventListener('scroll', () => {
  closeHeaderDropdowns();
}, { passive: true });

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeHeaderDropdowns();
  }
});
const closeToolbarPopovers = (exceptPopover = null) => {
  document.querySelectorAll('.tie-toolbar-popover[open]').forEach((popover) => {
    if (popover !== exceptPopover) {
      popover.open = false;
    }
  });
};

document.querySelectorAll('.tie-toolbar-popover').forEach((popover) => {
  popover.addEventListener('toggle', () => {
    if (popover.open) {
      closeToolbarPopovers(popover);
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.tie-toolbar-popover')) {
    closeToolbarPopovers();
  }
});

window.addEventListener('scroll', () => {
  closeToolbarPopovers();
}, { passive: true });

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeToolbarPopovers();
  }
});

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  if (searchModal) {
    const openSearch = () => {
      searchModal.classList.add('is-open');
      searchModal.setAttribute('aria-hidden', 'false');
      body.classList.add('tie-body-lock');
      window.setTimeout(() => searchInput?.focus(), 40);
    };

    const closeSearch = () => {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
      body.classList.remove('tie-body-lock');
    };

    document.querySelectorAll('[data-tie-search-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openSearch();
      });
    });

    searchModal.querySelectorAll('[data-tie-search-close]').forEach((button) => {
      button.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchModal.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }

  if (header && body?.classList.contains('template-index')) {
    const syncHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    syncHeaderState();
    window.addEventListener('scroll', syncHeaderState, { passive: true });
  }

  document.querySelectorAll('.tie-collection-page').forEach((collectionPage) => {
    const buttons = Array.from(collectionPage.querySelectorAll('[data-tie-collection-view]'));
    if (!buttons.length) return;

    const setView = (view) => {
      collectionPage.setAttribute('data-tie-collection-view', view);
      buttons.forEach((button) => {
        const isActive = button.dataset.tieCollectionView === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setView(button.dataset.tieCollectionView || 'grid');
      });
    });
  });

  document.querySelectorAll('[data-tie-accordion]').forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll('details'));
    if (!items.length) return;

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-card-media]').forEach((media) => {
    const frames = Array.from(media.querySelectorAll('.tie-product-card__frame'));
    const total = frames.length || 1;
    const counter = media.querySelector('.tie-product-card__counter-index');
    if (frames.length < 2) return;

    let index = 0;
    let timer = null;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (nextIndex) => {
      index = (nextIndex + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        frame.classList.toggle('is-active', frameIndex === index);
      });
      if (counter) {
        counter.textContent = String(index + 1);
      }
    };

    const start = () => {
      if (prefersReducedMotion) return;
      if (timer) return;
      timer = window.setInterval(() => show(index + 1), 1050);
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
      show(0);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    }, { threshold: 0.45 });

    observer.observe(media);

    media.addEventListener('pointerenter', start);
    media.addEventListener('pointerleave', stop);
    media.addEventListener('focusin', start);
    media.addEventListener('focusout', stop);
    if (media.parentNode) {
      media.parentNode.addEventListener('mouseleave', stop);
    }

    counter.textContent = String(Math.min(1, total));
    const totalNode = media.querySelector('.tie-product-card__counter-total');
    if (totalNode) {
      totalNode.textContent = String(total);
    }
  });

  document.querySelectorAll('[data-tie-motion]').forEach((shell) => {
    const row = shell.querySelector('[data-tie-motion-row]');
    if (!row) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoDelayMs = 3200;
    let motionTimer = null;

    const getScrollMax = () => Math.max(0, row.scrollWidth - row.clientWidth);
    const autoScroll = () => {
      const nextLeft = row.scrollLeft + Math.round(row.clientWidth * 0.82);
      row.scrollTo({
        left: nextLeft >= getScrollMax() ? 0 : nextLeft,
        behavior: 'smooth'
      });
    };
    const startMotion = () => {
      if (prefersReducedMotion || motionTimer || getScrollMax() === 0) return;
      motionTimer = window.setInterval(autoScroll, autoDelayMs);
    };
    const stopMotion = () => {
      window.clearInterval(motionTimer);
      motionTimer = null;
    };

    startMotion();

    row.addEventListener('mouseenter', stopMotion);
    row.addEventListener('mouseleave', startMotion);
    row.addEventListener('focusin', stopMotion);
    row.addEventListener('focusout', startMotion);

    shell.querySelectorAll('[data-tie-motion-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.tieMotionArrow === 'next' ? 1 : -1;
        row.scrollBy({
          left: direction * Math.round(row.clientWidth * 0.76),
          behavior: 'smooth'
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-why-slider]').forEach((shell) => {
  const row = shell.querySelector('[data-tie-why-slider-row]');
  if (!row) return;

  const getStep = () => {
    const firstSlide = row.querySelector('.tie-why__body');
    return firstSlide ? firstSlide.getBoundingClientRect().width : row.clientWidth;
  };

  const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);

  shell.querySelectorAll('[data-tie-why-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.tieWhyArrow === 'next' ? 1 : -1;
      const scrollEnd = getScrollEnd();
      const currentLeft = row.scrollLeft;
      const nextOffset = currentLeft + (direction * getStep());

      let target = Math.max(0, Math.min(scrollEnd, nextOffset));

      if (direction > 0 && currentLeft >= scrollEnd - 2) {
        target = 0;
      } else if (direction < 0 && currentLeft <= 2) {
        target = scrollEnd;
      }

      row.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    });
  });
});

  document.querySelectorAll('[data-tie-product-slider]').forEach((shell) => {
  const row = shell.querySelector('[data-tie-product-slider-row]');
  if (!row) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoDelayMs = 3600;
  let sliderTimer = null;

  const getStep = () => {
    const firstCard = row.querySelector('.tie-product-card');
    if (!firstCard) return row.clientWidth;

    const cardWidth = firstCard.getBoundingClientRect().width;
    const gap = parseFloat(window.getComputedStyle(row).columnGap || window.getComputedStyle(row).gap || 0);

    return cardWidth + gap;
  };

  const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);

  const scrollByDirection = (direction) => {
    const scrollEnd = getScrollEnd();
    const currentLeft = row.scrollLeft;
    const nextOffset = currentLeft + (direction * getStep());

    let target = Math.max(0, Math.min(scrollEnd, nextOffset));

    if (direction > 0 && currentLeft >= scrollEnd - 2) {
      target = 0;
    } else if (direction < 0 && currentLeft <= 2) {
      target = scrollEnd;
    }

    row.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  };

  const autoAdvance = () => {
    if (getScrollEnd() <= 0) return;
    scrollByDirection(1);
  };

  const startSlider = () => {
    if (prefersReducedMotion || sliderTimer || getScrollEnd() <= 0) return;
    sliderTimer = window.setInterval(autoAdvance, autoDelayMs);
  };

  const stopSlider = () => {
    window.clearInterval(sliderTimer);
    sliderTimer = null;
  };

  startSlider();

  row.addEventListener('mouseenter', stopSlider);
  row.addEventListener('mouseleave', startSlider);
  row.addEventListener('focusin', stopSlider);
  row.addEventListener('focusout', startSlider);

  shell.querySelectorAll('[data-tie-product-slider-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      stopSlider();
      const direction = button.dataset.tieProductSliderArrow === 'next' ? 1 : -1;
      scrollByDirection(direction);
    });
  });
});

  document.querySelectorAll('[data-tie-editorial-slider]').forEach((shell) => {
    const row = shell.querySelector('[data-tie-editorial-slider-row]');
    if (!row) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoDelayMs = 4600;
    let sliderTimer = null;

    const getStep = () => row.clientWidth;
    const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);
    const autoAdvance = () => {
      const nextOffset = row.scrollLeft + getStep();
      row.scrollTo({
        left: nextOffset >= getScrollEnd() - 2 ? 0 : nextOffset,
        behavior: 'smooth'
      });
    };

    const startSlider = () => {
      if (prefersReducedMotion || sliderTimer || getScrollEnd() <= 0) return;
      sliderTimer = window.setInterval(autoAdvance, autoDelayMs);
    };

    const stopSlider = () => {
      window.clearInterval(sliderTimer);
      sliderTimer = null;
    };

    startSlider();

    row.addEventListener('mouseenter', stopSlider);
    row.addEventListener('mouseleave', startSlider);
    row.addEventListener('focusin', stopSlider);
    row.addEventListener('focusout', startSlider);

    shell.querySelectorAll('[data-tie-editorial-slider-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.tieEditorialSliderArrow === 'next' ? 1 : -1;
        const nextOffset = row.scrollLeft + (direction * getStep());
        const target = direction > 0 && nextOffset > getScrollEnd()
          ? 0
          : Math.max(0, nextOffset);
        row.scrollTo({
          left: target,
          behavior: 'smooth'
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-product-marquee]').forEach((viewport) => {
  const track = viewport.querySelector('[data-tie-product-marquee-track]');
  if (!track) return;

  const shell = viewport.closest('.tie-product-marquee');
  const slider = viewport.closest('.tie-product-marquee__slider');
  track.style.transform = 'none';

  // Keep the carousel arrows vertically centered against the product image,
  // not against the full card (title, price and Add To Bag included).
  const positionMarqueeArrows = () => {
    if (!slider) return;

    const firstMedia = track.querySelector('.tie-product-card__media');
    if (!firstMedia) return;

    const sliderRect = slider.getBoundingClientRect();
    const mediaRect = firstMedia.getBoundingClientRect();
    const mediaCenterY = (mediaRect.top - sliderRect.top) + (mediaRect.height / 2);

    slider.style.setProperty('--tie-product-marquee-arrow-y', `${mediaCenterY}px`);
  };

  window.requestAnimationFrame(positionMarqueeArrows);
  window.addEventListener('resize', positionMarqueeArrows, { passive: true });

  if ('ResizeObserver' in window) {
    const marqueeResizeObserver = new ResizeObserver(positionMarqueeArrows);
    marqueeResizeObserver.observe(viewport);
  }

  const getStep = () => {
    const firstCard = track.querySelector('.tie-product-card');
    if (!firstCard) return viewport.clientWidth;

    const styles = window.getComputedStyle(track);
    const gapValue = styles.columnGap !== 'normal' ? styles.columnGap : styles.gap;
    const gap = parseFloat(gapValue) || 0;

    return firstCard.getBoundingClientRect().width + gap;
  };

  const getScrollEnd = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

  const scrollByDirection = (direction) => {
    const scrollEnd = getScrollEnd();
    const currentLeft = viewport.scrollLeft;
    const nextOffset = currentLeft + (direction * getStep());

    let target = Math.max(0, Math.min(scrollEnd, nextOffset));

    if (direction > 0 && currentLeft >= scrollEnd - 2) {
      target = 0;
    } else if (direction < 0 && currentLeft <= 2) {
      target = scrollEnd;
    }

    viewport.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  };

  shell?.querySelectorAll('[data-tie-product-marquee-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.tieProductMarqueeArrow === 'next' ? 1 : -1;
      scrollByDirection(direction);
    });
  });

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let dragged = false;

  viewport.addEventListener('mousedown', (event) => {
    isDown = true;
    dragged = false;
    startX = event.pageX - viewport.offsetLeft;
    scrollLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
  });

  viewport.addEventListener('mouseleave', () => {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });

  viewport.addEventListener('mouseup', () => {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });

  viewport.addEventListener('mousemove', (event) => {
    if (!isDown) return;

    event.preventDefault();

    const x = event.pageX - viewport.offsetLeft;
    const walk = (x - startX) * 1.4;

    if (Math.abs(walk) > 4) {
      dragged = true;
    }

    viewport.scrollLeft = scrollLeft - walk;
  });

  viewport.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
      }
    });
  });
});

  document.querySelectorAll('[data-tie-product-media]').forEach((gallery) => {
    const tiles = Array.from(gallery.querySelectorAll('[data-tie-product-media-tile]'));
    if (!tiles.length) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tiles.forEach((tile) => {
      const image = tile.querySelector(':scope > img');

if (!image) return;
      const stack = (tile.dataset.tieProductMediaStack || '').split('||').filter(Boolean);
      const maxFrames = Math.max(1, stack.length || 1);
      const frameLabels = [
        tile.dataset.tieProductMediaIndex || '1',
        tile.dataset.tieProductMediaNextIndex || tile.dataset.tieProductMediaIndex || '1'
      ];
      const counterIndex = tile.querySelector('.tie-product-media__counter-index');
      const counterTotal = tile.querySelector('.tie-product-media__counter-total');

      if (counterTotal) {
        counterTotal.textContent = String(tile.dataset.tieProductMediaTotal || counterTotal.textContent || maxFrames);
      }
      if (!image || maxFrames < 2) {
        if (counterIndex) {
          counterIndex.textContent = frameLabels[0];
        }
        return;
      }

      if (counterIndex) {
        counterIndex.textContent = frameLabels[0];
      }

      let index = 0;
      let timer = null;
      let hasStarted = false;
      const start = () => {
        if (prefersReducedMotion || timer) return;
        timer = window.setInterval(() => {
          index = (index + 1) % maxFrames;
          image.src = stack[index];
          if (counterIndex) {
            counterIndex.textContent = frameLabels[index] || String(index + 1);
          }
        }, 900);
      };
      const stop = () => {
        window.clearInterval(timer);
        timer = null;
      };

      const reset = () => {
        index = 0;
        image.src = stack[0];
        if (counterIndex) {
          counterIndex.textContent = frameLabels[0];
        }
      };

      tile.addEventListener('pointerenter', () => {
        hasStarted = true;
        start();
      });
      tile.addEventListener('pointerleave', () => {
        if (hasStarted) {
          stop();
          reset();
          hasStarted = false;
        }
      });
      tile.addEventListener('focusin', start);
      tile.addEventListener('focusout', stop);
    });
  });

  document.querySelectorAll('[data-tie-open-cart]').forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      if (!sideCart) return;
      event.preventDefault();
      await refreshCart(true);
    });
  });

  if (sideCart) {
    sideCart.querySelectorAll('[data-tie-side-cart-close]').forEach((button) => {
      button.addEventListener('click', closeSideCart);
    });

    sideCart.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-tie-cart-change]');
      if (button) {
        button.disabled = true;
        const line = Number(button.dataset.tieCartChange);
        const quantity = Number(button.dataset.tieCartQuantity);

        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ line, quantity })
          });
          await refreshCart(false);
        } finally {
          button.disabled = false;
        }
        return;
      }

      const upsellButton = event.target.closest('[data-tie-cart-upsell-add]');
      if (!upsellButton) return;

      upsellButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new URLSearchParams({
            id: upsellButton.dataset.tieCartUpsellAdd,
            quantity: '1'
          })
        });

        if (response.ok) {
          upsellButton.textContent = 'Added';
          await refreshCart(false);
        }
      } finally {
        window.setTimeout(() => {
          upsellButton.disabled = false;
          if (upsellButton.isConnected) {
            upsellButton.textContent = 'Add';
          }
        }, 900);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSideCart();
      }
    });
  }

  document.querySelectorAll('form[data-tie-add-to-cart]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      const isBuyNow = Boolean(submitter?.matches('[data-tie-buy-now]'));

      if (!sideCart && !isBuyNow) return;

      event.preventDefault();
      setSubmitting(form, true, submitter);

      try {
        const shopifyRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopifyRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        });

        if (!response.ok) {
          setSubmitting(form, false, submitter);
          return;
        }

        if (isBuyNow) {
          window.location.assign(`${shopifyRoot}cart`);
          return;
        }

        await refreshCart(true);
        showButtonSuccess(form);
      } finally {
        setSubmitting(form, false, submitter);
      }
    });
  });

  const refreshProductMediaCounters = (gallery) => {
  const tiles = Array.from(gallery.querySelectorAll('[data-tie-product-media-tile]'));
  const total = tiles.length;

  tiles.forEach((tile, index) => {
    const position = index + 1;
    const nextPosition = position >= total ? 1 : position + 1;
    const counterIndex = tile.querySelector('.tie-product-media__counter-index');
    const counterTotal = tile.querySelector('.tie-product-media__counter-total');

    tile.dataset.tieProductMediaIndex = String(position);
    tile.dataset.tieProductMediaNextIndex = String(nextPosition);
    tile.dataset.tieProductMediaTotal = String(total);

    if (counterIndex) counterIndex.textContent = String(position);
    if (counterTotal) counterTotal.textContent = String(total);
  });
};

const showSelectedVariantImageFirst = (select) => {
  const selectedOption = select.options[select.selectedIndex];
  if (!selectedOption) return;

  const variantMediaId = selectedOption.dataset.tieVariantMediaId;
  const variantImage = selectedOption.dataset.tieVariantImage;

  const productSection = select.closest('.tie-product-template');
  const gallery = productSection?.querySelector('[data-tie-product-media]');

  if (!gallery) return;

  let targetTile = null;

  if (variantMediaId) {
    targetTile = gallery.querySelector(`[data-tie-product-media-id="${variantMediaId}"]`);
  }

  if (targetTile) {
    gallery.prepend(targetTile);

    const image = targetTile.querySelector('img');
    const originalImage = (targetTile.dataset.tieProductMediaStack || '').split('||').filter(Boolean)[0];

    if (image && originalImage) {
      image.src = originalImage;
      image.srcset = originalImage;
    }

    refreshProductMediaCounters(gallery);
    return;
  }

  if (variantImage) {
    const firstTile = gallery.querySelector('[data-tie-product-media-tile]');
    const firstImage = firstTile?.querySelector('img');

    if (firstImage) {
      firstImage.src = variantImage;
      firstImage.srcset = variantImage;
    }
  }
};

const productVariantsScript = document.querySelector('[data-tie-product-variants-json]');
let productVariants = [];

try {
  productVariants = productVariantsScript
    ? JSON.parse(productVariantsScript.textContent || '[]')
    : [];
} catch (error) {
  productVariants = [];
}

const normalizeVariantValue = (value) => String(value || '').trim().toLowerCase();

const getSelectedProductVariant = (select) => (
  productVariants.find((variant) => String(variant.id) === String(select.value)) || null
);

const updateProductPrice = (select, selectedVariant) => {
  if (!selectedVariant) return;

  const productSection = select.closest('.tie-product-template');
  const priceElement = productSection?.querySelector('.tie-product-price');
  const stickyPriceElement = document.querySelector(
    '.tie-product-sticky-bar__meta span'
  );

  const price = Number(selectedVariant.price || 0);
  const compareAtPrice = Number(selectedVariant.compare_at_price || 0);

  if (priceElement) {
    priceElement.textContent = formatMoney(price);

    if (compareAtPrice > price) {
      const comparePriceElement = document.createElement('s');

      comparePriceElement.style.color = 'var(--tie-muted)';
      comparePriceElement.style.fontSize = '13px';
      comparePriceElement.textContent = formatMoney(compareAtPrice);

      priceElement.append(' ', comparePriceElement);
    }
  }

  if (stickyPriceElement) {
    stickyPriceElement.textContent = formatMoney(price);
  }
};

const updateProductAvailability = (select, selectedVariant) => {
  if (!selectedVariant) return;

  const isAvailable = Boolean(selectedVariant.available);
  const productForm = select.closest('.tie-product-form');

  const addButton = productForm?.querySelector('.tie-button--primary');
  const buyNowButton = productForm?.querySelector('.tie-button--buy-now');
  const stickyButton = document.querySelector(
    '.tie-product-sticky-bar__form .tie-button--primary'
  );

  if (addButton) {
    addButton.disabled = !isAvailable;
    addButton.textContent = isAvailable ? 'ADD TO BAG' : 'SOLD OUT';
    addButton.dataset.tieDefaultHtml = addButton.innerHTML;
  }

  if (buyNowButton) {
    buyNowButton.disabled = !isAvailable;
  }

  if (stickyButton) {
    stickyButton.disabled = !isAvailable;
    stickyButton.textContent = isAvailable ? 'ADD TO BAG' : 'SOLD OUT';
    stickyButton.dataset.tieDefaultHtml = stickyButton.innerHTML;
  }
};

document.querySelectorAll('[data-tie-variant-select]').forEach((select) => {
  const updateSelectedVariant = () => {
    const selectedVariant = getSelectedProductVariant(select);
    const colorIndex = Number.parseInt(
      select.dataset.tieColorOptionIndex,
      10
    );

    const selectedColor = (
      selectedVariant &&
      Array.isArray(selectedVariant.options) &&
      !Number.isNaN(colorIndex)
    )
      ? selectedVariant.options[colorIndex]
      : '';

    /*
     * Update the variant used by the sticky add-to-cart form.
     */
    syncVariantInputs(select.value);

    /*
     * Move the selected variant image to the first position.
     */
    showSelectedVariantImageFirst(select);

    /*
     * Update price, compare-at price and button availability.
     */
    updateProductPrice(select, selectedVariant);
    updateProductAvailability(select, selectedVariant);

    /*
     * Update the active colour swatch.
     */
    const productSection = select.closest('.tie-product-template');

    const swatches = productSection
      ? productSection.querySelectorAll('[data-tie-color-swatch]')
      : document.querySelectorAll('[data-tie-color-swatch]');

    swatches.forEach((swatch) => {
      const swatchValue = swatch.dataset.tieColorSwatch || '';

      const isActive = (
        normalizeVariantValue(swatchValue) ===
        normalizeVariantValue(selectedColor)
      );

      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', String(isActive));
    });
  };

  /*
   * Run once when the page loads.
   */
  updateSelectedVariant();

  /*
   * Run whenever the combined variant dropdown changes.
   */
  select.addEventListener('change', updateSelectedVariant);
});

document.querySelectorAll('[data-tie-color-swatch]').forEach((swatch) => {
  swatch.addEventListener('click', () => {
    const swatchValue = swatch.dataset.tieColorSwatch || '';
    const productSection = swatch.closest('.tie-product-template');

    const select = productSection?.querySelector(
      '[data-tie-variant-select]'
    );

    if (!select || !swatchValue) return;

    const colorIndex = Number.parseInt(
      select.dataset.tieColorOptionIndex,
      10
    );

    const currentVariant = getSelectedProductVariant(select);
    const normalizedSwatchValue = normalizeVariantValue(swatchValue);

    let targetVariant = null;

    /*
     * First try to find the selected colour while keeping
     * the current size and every other option unchanged.
     */
    if (!Number.isNaN(colorIndex)) {
      targetVariant = productVariants.find((variant) => {
        if (!variant.available || !Array.isArray(variant.options)) {
          return false;
        }

        const colorMatches = (
          normalizeVariantValue(variant.options[colorIndex]) ===
          normalizedSwatchValue
        );

        const otherOptionsMatch = (
          !currentVariant ||
          !Array.isArray(currentVariant.options)
        )
          ? true
          : variant.options.every((optionValue, optionIndex) => (
              optionIndex === colorIndex ||
              normalizeVariantValue(optionValue) ===
                normalizeVariantValue(currentVariant.options[optionIndex])
            ));

        return colorMatches && otherOptionsMatch;
      });

      /*
       * If that size-colour combination is unavailable,
       * use the first available variant of that colour.
       */
      if (!targetVariant) {
        targetVariant = productVariants.find((variant) => (
          variant.available &&
          Array.isArray(variant.options) &&
          normalizeVariantValue(variant.options[colorIndex]) ===
            normalizedSwatchValue
        ));
      }
    }

    const option = targetVariant
      ? Array.from(select.options).find((item) => (
          String(item.value) === String(targetVariant.id)
        ))
      : Array.from(select.options).find((item) => (
          !item.disabled &&
          normalizeVariantValue(item.text).includes(
            normalizedSwatchValue
          )
        ));

    if (!option) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
  const wishlistKey = 'tieWishlistProducts';

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  };

  const setWishlist = (items) => {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const escapeWishlistHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));
  const cleanWishlistText = (value = '') => String(value).replace(/<[^>]*>/g, '').trim();

  const ensureWishlistDrawer = () => {
    let drawer = document.querySelector('[data-tie-wishlist-drawer]');
    if (drawer) return drawer;

    document.body.insertAdjacentHTML('beforeend', `
      <aside class="tie-wishlist-drawer" aria-hidden="true" data-tie-wishlist-drawer>
        <button class="tie-wishlist-drawer__backdrop" type="button" aria-label="Close wishlist" data-tie-wishlist-close></button>
        <div class="tie-wishlist-drawer__panel" role="dialog" aria-modal="true" aria-label="Wishlist">
          <header class="tie-wishlist-drawer__header">
            <h2>Wishlist</h2>
            <button type="button" aria-label="Close wishlist" data-tie-wishlist-close>×</button>
          </header>
          <div class="tie-wishlist-drawer__body" data-tie-wishlist-items></div>
        </div>
      </aside>
    `);

    drawer = document.querySelector('[data-tie-wishlist-drawer]');

    drawer.querySelectorAll('[data-tie-wishlist-close]').forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.remove('tie-wishlist-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
    });

    return drawer;
  };

  const renderWishlistDrawer = () => {
    const drawer = ensureWishlistDrawer();
    const container = drawer.querySelector('[data-tie-wishlist-items]');
    const items = getWishlist();

    if (!container) return;

    if (!items.length) {
      container.innerHTML = '<p class="tie-wishlist-empty">Your wishlist is empty.</p>';
      return;
    }

    container.innerHTML = items.map((item) => `
      <div class="tie-wishlist-item">
        <a class="tie-wishlist-item__image" href="${escapeWishlistHtml(item.url)}">
          ${item.image ? `<img src="${escapeWishlistHtml(item.image)}" alt="${escapeWishlistHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="tie-wishlist-item__content">
          <a href="${escapeWishlistHtml(item.url)}">${escapeWishlistHtml(item.title)}</a>
          ${item.price ? `<p>${escapeWishlistHtml(cleanWishlistText(item.price))}</p>` : ''}
          <button type="button" data-tie-wishlist-remove="${escapeWishlistHtml(item.handle)}">Remove</button>
        </div>
      </div>
    `).join('');
  };

  const updateWishlistUI = () => {
    const items = getWishlist();
    const handles = new Set(items.map((item) => item.handle));

    document.querySelectorAll('[data-tie-wishlist-toggle]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const isActive = handles.has(handle);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    document.querySelectorAll('[data-tie-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });

    const drawer = document.querySelector('[data-tie-wishlist-drawer]');
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      renderWishlistDrawer();
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-tie-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const handle = toggle.dataset.productHandle;
      if (!handle) return;

      const product = {
        handle,
        title: toggle.dataset.productTitle || '',
        url: toggle.dataset.productUrl || '',
        image: toggle.dataset.productImage || '',
        price: cleanWishlistText(toggle.dataset.productPrice || '')
      };

      let items = getWishlist();
      const exists = items.some((item) => item.handle === handle);

      if (exists) {
        items = items.filter((item) => item.handle !== handle);
      } else {
        items.unshift(product);
      }

      setWishlist(items);
      updateWishlistUI();
      return;
    }

    const openButton = event.target.closest('[data-tie-wishlist-open]');
    if (openButton) {
      event.preventDefault();

      const drawer = ensureWishlistDrawer();
      renderWishlistDrawer();

      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tie-wishlist-open');
      return;
    }

    const removeButton = event.target.closest('[data-tie-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();

      const handle = removeButton.dataset.tieWishlistRemove;
      const items = getWishlist().filter((item) => item.handle !== handle);

      setWishlist(items);
      renderWishlistDrawer();
      updateWishlistUI();
    }
  });

  updateWishlistUI();
  const setupVariantMediaFilter = () => {
  const gallery = document.querySelector('[data-tie-product-media]');
  const tiles = Array.from(document.querySelectorAll('[data-tie-product-media-tile]'));
  const select = document.querySelector('[data-tie-variant-select]');

  if (!gallery || !tiles.length || !select) return;

  const variantsScript = document.querySelector('[data-tie-product-variants-json]');
  let variants = [];

  try {
    variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
  } catch (error) {
    variants = [];
  }

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/variant\s*:/g, '')
    .replace(/color\s*:/g, '')
    .replace(/colour\s*:/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const getSelectedVariant = () => variants.find((variant) => String(variant.id) === String(select.value));

  const getSelectedMediaKey = () => {
    const selectedVariant = getSelectedVariant();
    const colorIndex = parseInt(select.dataset.tieColorOptionIndex, 10);

    if (
      selectedVariant &&
      Array.isArray(selectedVariant.options) &&
      !Number.isNaN(colorIndex) &&
      selectedVariant.options[colorIndex]
    ) {
      return normalize(selectedVariant.options[colorIndex]);
    }

    const selectedText = select.options[select.selectedIndex]?.text || '';
    return normalize(selectedText.replace('- Sold out', ''));
  };

  const getMediaKeys = (rawValue) => {
    const value = String(rawValue || '').trim();

    if (!value) return [];

    const explicitVariantMatches = [...value.matchAll(/variant\s*:\s*([^|,;]+)/gi)]
      .map((match) => normalize(match[1]))
      .filter(Boolean);

    if (explicitVariantMatches.length) {
      return explicitVariantMatches;
    }

    return [normalize(value)];
  };

  const mediaMatchesVariant = (tile, selectedKey) => {
    const rawValue = tile.dataset.tieVariantMedia || '';

    if (!rawValue.trim()) {
      return true;
    }

    const mediaKeys = getMediaKeys(rawValue);

    if (mediaKeys.includes('all')) {
      return true;
    }

    return mediaKeys.some((mediaKey) => (
      mediaKey === selectedKey ||
      mediaKey.includes(selectedKey) ||
      selectedKey.includes(mediaKey)
    ));
  };

  const updateCounters = (visibleTiles) => {
    visibleTiles.forEach((tile, index) => {
      const counterIndex = tile.querySelector('.tie-product-media__counter-index');
      const counterTotal = tile.querySelector('.tie-product-media__counter-total');

      if (counterIndex) {
        counterIndex.textContent = String(index + 1);
      }

      if (counterTotal) {
        counterTotal.textContent = String(visibleTiles.length);
      }
    });
  };

  const applyVariantMediaFilter = () => {
    const selectedKey = getSelectedMediaKey();

    if (!selectedKey) return;

    let visibleTiles = [];

    tiles.forEach((tile) => {
      const shouldShow = mediaMatchesVariant(tile, selectedKey);

      tile.hidden = !shouldShow;
      tile.classList.toggle('is-hidden-by-variant', !shouldShow);

      if (shouldShow) {
        visibleTiles.push(tile);
      }
    });

    if (!visibleTiles.length) {
      tiles.forEach((tile) => {
        tile.hidden = false;
        tile.classList.remove('is-hidden-by-variant');
      });

      visibleTiles = tiles;
    }

    updateCounters(visibleTiles);

    if (typeof gallery.scrollTo === 'function') {
      gallery.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });
    }
  };

  applyVariantMediaFilter();
  select.addEventListener('change', applyVariantMediaFilter);
};

setupVariantMediaFilter();
  setupReadMoreCards();
  refreshCart(false);
})();
